import {UsernameFormSessionComponent} from './usernameFormSession.component';
import { ComponentRef, ViewContainerRef } from '@angular/core';

class UsernameFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: any;
  subflow: string;
  errorCode:string;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  usernameFormSessionCompRef: ComponentRef<UsernameFormSessionComponent>;

  constructor(formId: string, payload: object) {
      this.formId = formId;
      this.payload = payload;
      this.subflow = this.payload.actions[0].subflow;
      this.errorCode = this.payload.actions[0].code;
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    this.viewContainerRef.clear();

    this.usernameFormSessionCompRef = this.viewContainerRef.createComponent(UsernameFormSessionComponent);
    this.usernameFormSessionCompRef.instance.onSubmitUserId = this.onSubmitUserData.bind(this);
    this.usernameFormSessionCompRef.instance.onForgotUserEmailSubmit = this.onForgotUsernameSubmit.bind(this);
    this.usernameFormSessionCompRef.instance.onRegisterClick = this.onRegisterClick.bind(this);
    this.usernameFormSessionCompRef.instance.onForgotUsernameAccountClick = this.onForgotUsernameAccountClick.bind(this);
    this.usernameFormSessionCompRef.instance.onVerifyUserEmailSubmit = this.onRegPendingVerifyEmail.bind(this);
    this.usernameFormSessionCompRef.instance.onForgotUsernameLinkClick = this.onForgotUsernameLinkSubmit.bind(this);
    this.usernameFormSessionCompRef.instance.onRegisterLinkClick = this.onRegisterLinkSubmit.bind(this);
    this.usernameFormSessionCompRef.instance.onForgotUsernameAccountLinkClick = this.onForgotUsernameAccountLink.bind(this);

    this.usernameFormSessionCompRef.instance.loginHint = this.subflow;
    this.usernameFormSessionCompRef.instance.usernameErrorCode = this.errorCode;
    this.usernameFormSessionCompRef.instance.payload = this.payload;

    const journeyPayload = this.payload as JourneyPayload;

    const action = journeyPayload.actions[0] as ActionsInPayload;

    this.usernameFormSessionCompRef.instance.flowFromPayload = 'login';

    const loginHintEmail = action.loginhint === null ? '' : action.loginhint;
    this.clientContext['cookieService'].set('login-hint-email', loginHintEmail, undefined, undefined, null, true, 'None');

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          this.submitBlock = null; // prevent reuse of a settled promise
        } catch (e) {
          console.error(e);
        }
      };
    });
  }
  onContinue(payload: object): void {
  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];

    if (errorPayload.code === 'BL02'){
      let appendChar = '?';
      if (url.includes('?'))
      {
         appendChar = '&';
      }
      window.location.href = url + appendChar + 'error=' + errorPayload.code + '&error_description=suspended' 
      + '&lang=' + this.clientContext['cookieService'].get('lang')
      + '&state=' + state;
    }
    else if (errorPayload.code === 'RC01'){
      const url = this.clientContext['redirect_uri'];
      const state = this.clientContext['state'];
      const errorCode  = 'rc01';
      let appendChar = '?';
      if (url.includes('?'))
      {
          appendChar = '&';
      }
      window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=rc01'
      + '&lang=' + this.clientContext['cookieService'].get('lang')
      + '&state=' + state;

    }
    else if (errorPayload.code === 'FB01'){
      this.processRecaptchaFailure();
    }
    else {
      this.clientContext['cookieService'].set('loginStoreErrorCode', 
      errorPayload.code ? errorPayload.code : null, undefined, undefined, null, true, 'None');
    }
  }

  /** Non UIFormSession interface Functions */
  private onSubmitUserData(payload: object) {
    this.clientContext['cookieService'].delete('flow');
    this.clientContext['cookieService'].set('userEmail', payload['username'], undefined, undefined, null, true, 'None');

    this.clientContext['cookieService'].set('userEmail-username', payload['username'], undefined, undefined, null, true, 'None');

    this.clientContext['cookieService'].set('rememberMe', payload['rememberme'], undefined, undefined, null, true, 'None');
    const data = payload;
    this.submitBlock(data);
  }

  private onForgotUsernameSubmit(payload: object) {
    this.clientContext['cookieService'].set('flow', 'username', undefined, undefined, null, true, 'None');
    this.clientContext['cookieService'].set('forgot-username', payload['username'], undefined, undefined, null, true, 'None');

    const data = payload;
    this.submitBlock(data);
  }

  private onRegPendingVerifyEmail(payload: object) {

    const data = payload;
    this.clientContext['cookieService'].delete('verifyEmail');
    this.submitBlock(data);
  }

  private onRegisterClick(brand: string){

    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'register';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=register'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

  private onForgotUsernameAccountClick(){
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'forgotUsername';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=forgotUsername'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

  private processRecaptchaFailure(){
    this.clientContext['cookieService'].set('useRecaptchaV3', false, undefined, undefined, null, true, 'None');
    this.clientContext['cookieService'].set('reCaptchaVersion', 'V2', undefined, undefined, null, true, 'None');

    setTimeout(() => this.usernameFormSessionCompRef.instance.validateAndSubmit(), 10);
  }

   private onForgotUsernameLinkSubmit() {
    const data = {action: 'escape_forgotusername'};
    this.submitBlock(data);
  }

   private onRegisterLinkSubmit() {
    const data = {action: 'escape_register'};
    this.submitBlock(data);
  }

  private onForgotUsernameAccountLink(){
    const data = {action: 'escape_account-info-forgotusername'};
    this.submitBlock(data);
  }
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default UsernameFormSession;
